import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { FavoriteProvider } from './contexts/FavoriteContext';
import AuthPage from './pages/AuthPage';
import LoginForm from './components/auth/LoginForm';
import RegisterForm from './components/auth/RegisterForm';
import DashboardLayout from './layouts/DashboardLayout';
import CryptoChart from './components/crypto/CryptoChart';
import Portfoy from './pages/Portfoy';
import SinyalAyarlari from './pages/SinyalAyarlari';
import IncomingSignals from './pages/IncomingSignals';
import { useCryptoStore } from './store/cryptoStore';
import { createGlobalStyle } from 'styled-components';
import SmartSignals from './pages/SmartSignals';




const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Poppins', sans-serif;
  }

  body {
    background-color: #0a0a0f;
    color: white;
  }

  .tradingview-widget-container {
    height: 100%;
  }
`;

function App() {
  const { selectedChart, setSelectedChart } = useCryptoStore();

  return (
    <Router future={{ 
      v7_startTransition: true,
      v7_relativeSplatPath: true
    }}>
      <AuthProvider>
        <FavoriteProvider>
          <GlobalStyle />
          <Routes>
            <Route path="/" element={<Navigate to="/auth/login" replace />} />
            
            {/* Auth Routes */}
            <Route path="/auth/*" element={<AuthPage />}>
              <Route path="login" element={<LoginForm />} />
              <Route path="register" element={<RegisterForm />} />
              <Route index element={<Navigate to="login" replace />} />
            </Route>

            {/* Dashboard Routes */}
            <Route path="/dashboard" element={<DashboardLayout />}>
              <Route index element={<Portfoy />} />
              <Route path="portfoy" element={<Portfoy />} />
              <Route path="sinyal-ayarlari" element={<SinyalAyarlari />} />
              <Route path="signals" element={<IncomingSignals />} />
              <Route path="smart-signals" element={<SmartSignals />} /> 

            </Route>

            {/* Fallback Route */}
            <Route path="*" element={<Navigate to="/auth/login" replace />} />
          </Routes>

          {selectedChart && (
            <CryptoChart 
              symbol={selectedChart} 
              onClose={() => setSelectedChart(null)} 
            />
          )}
        </FavoriteProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;